/**
 * Ролевой гейт для Route-элементов. Вынесен из App.tsx в отдельный модуль,
 * чтобы страницы с повышенным minRole (например, мастер импорта каталога)
 * можно было протестировать через ТОТ ЖЕ самый механизм, которым реально
 * защищены маршруты в приложении — а не через повторную реализацию проверки
 * роли в тесте, которая могла бы разойтись с реальным guard'ом.
 */
import React from 'react';
import { Result } from 'antd';
import { useAuthStore } from '../store/authStore';

export const ROLE_LEVELS: Record<string, number> = { operator: 0, manager: 1, admin: 2, owner: 3 };

export function hasMinimumRole(role: string | undefined, minimum: string | undefined): boolean {
  if (!minimum) return true;
  return role !== undefined && (ROLE_LEVELS[role] ?? -1) >= (ROLE_LEVELS[minimum] ?? 4);
}

const RoleRoute: React.FC<{ minRole: string; children: React.ReactNode }> = ({ minRole, children }) => {
  const role = useAuthStore((s) => s.admin?.role);
  if (!hasMinimumRole(role, minRole)) {
    return <Result status="403" title="Нет доступа" subTitle="Этот раздел недоступен для вашей роли в выбранной компании." />;
  }
  return <>{children}</>;
};

export default RoleRoute;
